import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

class Header extends React.Component {
    openNav(e) {
        e.preventDefault()

        let btn = document.getElementById("side-menu")
        btn.classList.toggle('st-effect-1')
    }

    render() {
        return (
            <header className="header">
                <div className="content-container">
                    <div className="header__content">
                        <button className="mobile-button" onClick={this.openNav}>&#9776;</button>
                        <Link className="header__title" to="/dashboard">
                            <h1>Expensify</h1>
                        </Link>
                    </div>
                </div>
            </header>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    startLogout: () => dispatch(startLogout())
});

export default connect(undefined, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Nav.js